import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

const initialState = {
  isLoading: false,
  fetchLoading: false,
  trips: [],
};

export const listenTrips = createAsyncThunk(
  "listenTrips/socket",
  async ({ userId }, thunkApi) => {
    try {
      window.Pusher = Pusher;
      const echo = new Echo({
        broadcaster: "pusher",
        key: process.env.REACT_APP_PUSHER_ECHO_KEY,
        cluster: "ap2",
        encrypted: true,
        authEndpoint: `${process.env.REACT_APP_HOST_API_KEY}/broadcasting/auth`, // Ensure this matches your endpoint
        auth: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      });

      const channel = echo
        .private(`trip.requests.${userId}`)
        .listen("new.trip", (data) => {
          thunkApi.dispatch(addMessage(data.message));
        });

      return () => {
        channel.stopListening("new.trip");
        echo.disconnect();
      };
    } catch (error) {
      console.log(error, "error");
    }
  }
);

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    addMessage: (state, action) => {
      state.trips.push(action.payload);
    },
    clearMessages: (state) => {
      state.trips = [];
    },
  },
});

export default socketSlice.reducer;

export const { addMessage, clearMessages } = socketSlice.actions;
